import { createSlot } from "lib/@components/slot/create-slot"

export const ScheduleChanges = createSlot("ScheduleChanges")
